(ns rothko.form2.validation
  (:require [clojure.spec.alpha :as s]
            [expound.alpha :as expound]
            [medley.core :refer [map-vals]]
            [rothko.form2.core :as core]
            [taoensso.timbre :as log]))

;; rothko#229 disabled? and validation should be an appearance
;; validation of field-props to render-fn
;; check all field-props name field and map key are the same

(defn clear-field-validation-state!
  [!state name]
  (swap! !state (fn [state]
                  (-> state
                      ;; Don't use `medley.core/dissoc-in` as it removes `empty?` keys
                      (update-in [:rothko.form2.component/fields name ::current-messages] empty)
                      (update-in [:rothko.form2.component/fields name ::errors] empty)
                      (assoc-in [:rothko.form2.component/fields name ::valid?] true)))))

(defn set-field-validation-state!
  [!state name messages errors]
  (swap! !state (fn [state]
                  (-> state
                      (assoc-in [:rothko.form2.component/fields name ::current-messages] messages)
                      (assoc-in [:rothko.form2.component/fields name ::errors] errors)
                      (assoc-in [:rothko.form2.component/fields name ::valid?] false)))))

(defn field-type-dispatch
  [_ field]
  (cond
    (and (contains? field ::fn)
         (contains? field ::spec))
    (do
      ;; TODO we need a way to show the ex-info data in JS
      (print field)
      (throw (ex-info "rothko.form does not support both fn and spec validation at the same time" {})))

    (and (contains? field ::messages)
         (contains? field ::fn))
    {:field-validation-type :fn}

    (and (contains? field ::spec)
         (contains? field ::messages))
    {:field-validation-type :spec}

    (contains? field ::fn)
    (do
      ;; TODO we need a way to show the ex-info data in JS
      (print field)
      (throw (ex-info "validation without messages is not currently implmenented" {})))

    (contains? field ::spec)
    (do
      ;; TODO we need a way to show the ex-info data in JS
      (print field)
      (throw (ex-info "validation without messages is not currently implmenented" {})))

    :else
    {:field-validation-type :none}))

(defmulti validate-field! #'field-type-dispatch)

(defmethod validate-field!
  {:field-validation-type :fn}
  [!state {:keys [::messages :rothko.form2.component/name] validation-fn ::fn :as field}]
  (let [form-current (:rothko.form2.component/current @!state)
        current (get form-current name)
        ;; TODO rothko#230 we need to spec these validation-fns as they need to
        ;; return arrays of error keys
        result (validation-fn form-current current)
        valid? (= ::success result)]
    (if valid?
      (clear-field-validation-state! !state name)
      (do
        (assert (sequential? result) "Validation fn result must be a sequence of `::validation/messages` keys.")
        (let [validation-messages (map #(get messages %) result)]
          (if (not-any? nil? validation-messages)
            (set-field-validation-state! !state name validation-messages result)
            (throw (ex-info "Validation error with no corresponding message found" {}))))))
    valid?))

(defn failed-specs
  [data]
  ;; I'm not sure how much of an issue the `first` call is. The
  ;; way we're using this function is on the individual field specs
  ;; (i.e. there will only be one failure as spec stops validating
  ;; after the first failure. See rothko#207
  (->> data ::s/problems (map :via) first))

(defmethod validate-field!
  {:field-validation-type :spec}
  [!state {:keys [::spec ::messages :rothko.form2.component/name] :as field}]
  (let [current (get-in @!state [:rothko.form2.component/fields name :rothko.form2.component/current])
        valid? (s/valid? spec current)]
    (if valid?
      (clear-field-validation-state! !state name)
      (let [errors (failed-specs (s/explain-data spec current))
            ;; rothko#207 it would be nice to be able to get all spec errors
            current-validation-messages [(some messages (reverse errors))]]
        (if (not-any? nil? current-validation-messages)
          (set-field-validation-state! !state name current-validation-messages errors)
          (throw (ex-info "Validation error with no corresponding message found" {})))))
    valid?))

(defmethod validate-field!
  {:field-validation-type :none}
  [_ _]
  ;; Do we need something like this for no field validation?
  ;; (swap! !state assoc ::valid? true)
  ::no-validation)

(defn form-type-dispatch
  [_ form-props]
  (cond
    (and (contains? form-props ::fn)
         (contains? form-props ::spec))
    (do
      ;; TODO we need a way to show the ex-info data
      (print form-props)
      (throw (ex-info "rothko.form does not support both fn and spec validation at the same time" {})))

    (and (contains? form-props ::messages)
         (contains? form-props ::fn))
    {:form-validation-type :fn}

    (and (contains? form-props ::messages)
         (contains? form-props ::spec))
    {:form-validation-type :spec}

    (contains? form-props ::fn)
    (do
      ;; TODO we need a way to show the ex-info data
      (print form-props)
      (throw (ex-info (str "Fn validation without messages is not currently implmenented: "
                           (::fn form-props))
                      {})))

    (contains? form-props ::spec)
    (do
      ;; TODO we need a way to show the ex-info data
      (print form-props)
      (throw (ex-info (str "Spec validation without messages is not currently implmenented: "
                           (::spec form-props))
                      {})))

    :else
    {:form-validation-type :none}))

(defmulti validate-form! #'form-type-dispatch)

(defn set-form-invalid!
  [!state messages errors]
  (swap! !state (fn [state]
                  (assoc state
                         ::form-messages messages
                         ::form-errors errors
                         ::valid? false)))
  false)

(defn set-form-valid!
  [!state]
  (swap! !state (fn [state]
                  (assoc state
                         ::form-messages ::success
                         ::form-errors ::success
                         ::valid? true)))
  true)

(defmethod validate-form!
  {:form-validation-type :spec}
  [!state {:keys [::spec ::messages] :as form-props}]
  (let [current (core/form-current @!state)
        valid? (s/valid? spec current)]
    (if valid?
      (set-form-valid! !state)
      (let [errors (failed-specs (s/explain-data spec current))
            ;; rothko#207 it would be nice to be able to get all spec errors
            messages [(some messages (reverse errors))]]
        (set-form-invalid! !state messages errors)))))

(defmethod validate-form!
  {:form-validation-type :fn}
  [!state {:keys [::messages] validation-fn ::fn :as form-props}]
  (let [current (core/form-current @!state)
        result (validation-fn current)]
    (if (= ::success result)
      (set-form-valid! !state)
      (let [messages (select-keys messages result)]
        (do
          (when (not-any? nil? messages)
            (log/warn "Validation error with no corresponding message found"
                      {:result result
                       :messages messages}))
          (set-form-invalid! !state messages result))))))

(defmethod validate-form!
  {:form-validation-type :none}
  [!state _]
  (swap! !state (fn [state]
                  (let [current (:rothko.form2.component/current state)
                        state-with-current-value (cond-> state current (assoc :rothko.form2.component/value current))
                        fields-valid? (->> state
                                           (:rothko.form2.component/fields)
                                           (vals)
                                           (remove (fn [{:keys [:rothko.form2.component/disabled?] :as field}]
                                                     (core/compute-disabled? disabled? state-with-current-value field)))
                                           (map ::valid?)
                                           (remove nil?)
                                           (every? true?))]
                    (assoc state ::valid? fields-valid?)))))

(defn field-props->render-props
  [{:keys [:rothko.form2.component/name] :as field-config} !state form-props]
  (assoc field-config
         ::current-messages (get-in @!state [:rothko.form2.component/fields name ::current-messages])
         ::valid? (get-in @!state [::valid name])))

(defn add-constructor-form-props
  [form-settings !state field-settings]
  (assoc form-settings
         ::get-valid? #(::valid? @!state)
         ::validate! #(core/mark-all-fields-dirty! !state field-settings)))

(defn init-field-states
  [field-settings]
  (assoc field-settings
         ::valid? nil
         ::errors {}
         ::current-messages {}))

(defn init-form-state
  [{:keys [:rothko.form2.component/fields] :as state}]
  (let [fields (map-vals init-field-states fields)]
    (assoc state
           :rothko.form2.component/fields fields
           ::current-messages {}
           ::errors {}
           ::valid? nil)))

(defn call-validate!
  [{::keys [validate!]}]
  (validate!))
